import { htmlSafe } from '@ember/template';
import type { SafeString } from '@ember/template/-private/handlebars';

export default function safeString(str: string | undefined): SafeString {
  return htmlSafe(str ?? '');
}
